/*
 * @Descripttion: 科研合作
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-20 16:50:17
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-03-29 09:17:51
 */

const scienceResearch = {
  title: '科研合作',
  des: 'Research cooperation',
  intelligence: {
    title: '人工智能引领智慧医疗',
    des: '脉流科技在计算仿真、人工智能和医学影像等方面技术积累尤为深厚，核心团队不仅懂技术，对临床也有深入探究，并与国内多家顶级医院定制合作。',
    list: [
      {
        title: '专业的技术团队',
        des: '脉流科技拥有一批在计算仿真、人工智能和医学影像等方面经验丰富的团队，团队的技术积累深厚，在学术行业中发表了数百篇论文。'
      },
      {
        title: '可靠的云平台',
        des: '强大可靠的服务器平台，保证系统稳定运行。高效稳定的云服务器，支持多中心同时操作。专业的人工智能处理硬件，运算处理性能更胜一筹。'
      },
      {
        title: '个性化科研服务',
        des: '通过计算机视觉及深度学习等方法为医生提供病人数据精准分析服务，提高诊断精度，制定个性化脑血管病治疗方案，提升病人治疗水平。'
      }
    ]
  },
  field: {
    title: '科研合作领域',
    des: '创始团队是心脑血管疾病血流动力学研究领域的专家，拥有逾二十年世界级心脑血管领域科研经验。脉流科技与国内外上百家心脑血管医疗机构建立深度的临床合作，在学术行业中发表了数百篇论文。',
    list: [
      {
        title: '临床科室&体检中心',
        des: '公司的人工智能算法以及技术团队非常欢迎医院临床的各个科室提出创新的合作理念，将我们当前用于心脑血管病的技术进一步扩大到临床各个科室，通过临床试验验证新的理念，革新诊疗技术。我们也能为体检中心提供多种心血管疾病的无创检测，适应于普通人群体检或高风险人群筛查。'
      },
      {
        title: '业界领域公司',
        des: '脉流科技欢迎业界相关领域公司与我们展开合作。公司的人工智能产品软件，可以搭配大型影像设备（CT，MRI等）提供智能工作站，对疾病做筛查，并排序病例的优先级甚至协助医生出具有参考价值的诊断报告，从方方面面提升医生的效率，降低人工成本，最大化的发挥硬件设备功能，提高医生诊断效率。'
      }
    ]
  },
  intention: {
    title: '合作意向',
    des: '我们欢迎和医学领域各界相关人士展开科研合作，共同将人工智能技术应用于医疗行业，开展学术前沿研究。',
    form: {
      name: '您的称呼',
      company: '单位名称',
      contact: '联系方式',
      content: '合作内容',
      btn: '提交咨询'
    }
  }
}

export default scienceResearch
